import { ModuleKey } from './billing-definitions';

/**
 * Maps a purchasable module to the token slug used to compose its CSS custom
 * properties: `var(--color-<slug>)`, `var(--color-<slug>-bg)`,
 * `var(--color-<slug>-border)`. Token definitions live in
 * `libs/angular/ui/src/lib/v3/styles/module-tokens.css`.
 *
 * 'project' is the always-available core module and has no distinct theme.
 */
export const MODULE_THEME: Record<Exclude<ModuleKey, 'project'>, string> = {
  monitoring: 'monitoring',
  analytics: 'analytics',
  simulations: 'simulations',
};
